<template>
  <div class="item-contain">
    <!-- <div v-if="isParent" class="bind-student-table"> -->
      <!-- <el-card>
        <div slot="header">已绑定学生信息</div>
        <el-table :data="bindStudents" border style="width: 100%;">
          <el-table-column prop="parentId" label="家长ID" width="120" />
          <el-table-column prop="studentId" label="学生ID" width="120" />
          <el-table-column prop="studentName" label="学生用户名" width="150" />
        </el-table>
      </el-card> -->
    <!-- </div> -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>个人中心</span>
        <el-button v-if="userRole === 1" style="float: right; padding: 3px 0; margin-right: 15px" type="text" size="mini"
          @click="goBackToAMCCourse">
          返回备考中心
        </el-button>
        <el-button v-if="userRole === 1" style="float: right; padding: 3px 0; margin-right: 15px" type="text" size="mini"
          @click="recreatePlan">
          重新制定计划
        </el-button>
        <el-button v-if="!fromAmc && !hasJoinedClass && !isAdmin" style="float: right; padding: 3px 0; margin-right: 15px"
          type="text" size="mini" @click="addClassBt">
          加入班级</el-button>
        <el-button v-if="!fromAmc && isParent" style="float: right; padding: 3px 0; margin-right: 15px" type="text" size="mini"
          @click="bindUser">
          绑定用户
        </el-button>
        <!-- 学生绑定信息显示 -->
        <div v-if="!fromAmc && userRole === 1 && isStudentBound && studentBindInfo" style="float: right; padding: 3px 0; margin-right: 15px; font-size: 12px; color: #666;">
          <span style="margin-right: 10px;">姓名：{{studentBindInfo.name}}</span>
          <span style="margin-right: 10px;">学号：{{studentBindInfo.studentNum}}</span>
          <span style="margin-right: 10px;">学校：{{studentBindInfo.schoolName}}</span>
          <el-button type="text" size="mini" @click="showUnbindDialog" style="color: #f56c6c;">解绑</el-button>
        </div>
        <!-- 绑定学号按钮 -->
        <el-button v-if="!fromAmc && userRole === 1 && !isStudentBound" style="float: right; padding: 3px 0; margin-right: 15px" type="text" size="mini"
          @click="showStudentBindDialog">
          绑定学号
        </el-button>
        <!-- 临时测试按钮，不依赖后端API -->
        <el-button v-if="!fromAmc && userRole === 1" style="float: right; padding: 3px 0; margin-right: 15px" type="text" size="mini"
          @click="showStudentBindDialog">
          测试绑定学号
        </el-button>
      </div>

      <!-- 合并个人详细信息表单 -->
      <div class="detail-info-section">
        <el-dialog width="400px" :show-close="false" :close-on-click-modal="false" title="上传头像"
          :visible.sync="fileDialogVisible">
          <el-upload class="upload-demo" drag action="xxxxxx" multiple :limit="1" accept="png, jpg, jpeg, bmp"
            :auto-upload="false" :on-remove="handleRemove" :on-change="handleFileChange" :file-list="fileList">
            <i class="el-icon-upload" />
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div slot="tip" class="el-upload__tip">
              只能上传"png", "jpg", "jpeg",
              "bmp"文件，且不超过2MB。注:右上角头像，重新登录更新
            </div>
          </el-upload>
          <div slot="footer" class="dialog-footer">
            <el-button @click="fileDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="importAvatar">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="加入班级" :visible.sync="addClassDialogVisible">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form :model="form">
                <el-form-item label="班级口令">
                  <el-input v-model="form.code" autocomplete="off" />
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <div slot="footer" class="dialog-footer">
            <el-button @click="addClassDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="addClass">确 定</el-button>
          </div>
        </el-dialog>

        <div class="user-info-container">
          <el-form :model="userForm" :rules="rules" ref="userForm" label-width="100px" class="user-form"
            v-loading="loading">
            <el-form-item label="AMC等级" v-if="fromAmc">
              <el-input :value="amcLevelDisplay || '—'" disabled></el-input>
            </el-form-item>
            <el-form-item label="备考年份" v-if="fromAmc">
              <el-input :value="amcYearDisplay || '—'" disabled></el-input>
            </el-form-item>
            <el-form-item label="头像">
              <div class="avatar-container" @click="fileDialogVisible = true">
                <img :src="avatarUrl" class="user-avatar" @error="handleAvatarError">
                <div class="avatar-overlay">
                  <i class="el-icon-camera"></i>
                  <span>点击更换</span>
                </div>
              </div>
            </el-form-item>

            <el-form-item label="姓名" prop="realName">
              <el-input v-model="userForm.realName" placeholder="请输入姓名"></el-input>
            </el-form-item>

            <el-form-item label="性别" prop="gender">
              <el-radio-group v-model="userForm.gender">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="出生日期" prop="birthday">
              <el-date-picker v-model="userForm.birthday" type="date" placeholder="选择日期" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="账号" prop="userName">
              <el-input v-model="userForm.userName" placeholder="请输入账号" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="联系方式" prop="phone">
              <el-input v-model="userForm.phone" placeholder="请输入联系方式"></el-input>
            </el-form-item>

            <el-form-item label="邮箱" prop="email">
              <el-input v-model="userForm.email" placeholder="请输入邮箱"></el-input>
            </el-form-item>

            <!-- <el-form-item label="年级" prop="major" v-if="userRole === 1">
              <el-input v-model="userForm.major" placeholder="请输入年级"></el-input>
            </el-form-item> -->

            <el-form-item>
              <el-button type="primary" @click="submitForm('userForm')" :loading="loading">保存</el-button>
              <el-button @click="CloseForm()">关闭</el-button>
              <el-button type="danger" plain @click="showDeleteAccountDialog" style="margin-left: 20px">注销账户</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-card>

    <!-- 在 template 的最后添加这个弹窗组件 -->
    <el-dialog
      title="绑定用户"
      :visible.sync="bindUserDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      :before-close="handleBindDialogClose"
      :close-on-press-escape="false"
    >
      <div class="bind-user-dialog">
        <div class="search-section">
          <el-input
            v-model="searchUsername"
            placeholder="请输入用户名"
            class="search-input"
            :disabled="searchLoading"
            @keyup.enter.native="searchUser"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchUser"
              :loading="searchLoading"
            >搜索</el-button>
          </el-input>
        </div>

        <div v-if="searchError" class="search-error">
          {{ searchError }}
        </div>

        <div v-if="searchResult" class="search-result">
          <el-table
            :data="[searchResult]"
            border
            style="width: 100%"
            v-loading="searchLoading"
          >
            <el-table-column
              prop="userName"
              label="用户名"
              width="120"
            />
            <el-table-column
              prop="realName"
              label="真实姓名"
              width="120"
            />
            <el-table-column
              prop="school"
              label="学校"
              min-width="150"
            />
            <el-table-column
              prop="major"
              label="年级"
              width="120"
            />
            <el-table-column
              label="操作"
              width="120"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  @click="confirmBindUser(scope.row)"
                  :loading="bindLoading"
                  :disabled="bindLoading"
                >绑定</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-else-if="searchUsername && !searchLoading" class="no-result">
          <el-empty description="未找到相关用户" />
        </div>
      </div>
    </el-dialog>

    <!-- 学生绑定对话框 -->
    <el-dialog
      title="绑定学号"
      :visible.sync="studentBindDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      :before-close="handleStudentBindDialogClose"
    >
      <div class="student-bind-dialog">
        <el-alert
          title="重要提示"
          type="warning"
          :closable="false"
          show-icon
          style="margin-bottom: 20px;">
          <div slot="description">
            <p>请确保学校名称输入正确，这将影响您的学号绑定。</p>
            <p>如果系统中已存在相同的学号和学校，将直接绑定；否则将创建新的学生记录。</p>
          </div>
        </el-alert>

        <el-form :model="studentBindForm" :rules="studentBindRules" ref="studentBindForm" label-width="100px">
          <el-form-item label="姓名">
            <el-input v-model="studentBindForm.name" :disabled="true" style="background-color: #f5f7fa;"></el-input>
            <div class="form-item-tip">系统将使用您的真实姓名进行绑定</div>
          </el-form-item>

          <el-form-item label="学号" prop="studentId">
            <el-input v-model="studentBindForm.studentId" placeholder="请输入学号"></el-input>
          </el-form-item>

          <el-form-item label="学校名称" prop="schoolName">
            <el-input v-model="studentBindForm.schoolName" placeholder="请输入学校名称"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleStudentBindDialogClose">取 消</el-button>
        <el-button type="primary" @click="submitStudentBind" :loading="studentBindLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 解绑确认对话框 -->
    <el-dialog
      title="解绑学号"
      :visible.sync="unbindDialogVisible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      center>
      <div slot="title" class="dialog-header">
        <span class="dialog-title">解绑学号</span>
        <el-button type="text" icon="el-icon-close" @click="handleUnbindDialogClose" class="dialog-close-btn"></el-button>
      </div>

      <div style="text-align: center; padding: 20px 0;">
        <i class="el-icon-warning" style="font-size: 48px; color: #f56c6c; margin-bottom: 16px;"></i>
        <p style="font-size: 16px; margin-bottom: 8px;">确认要解绑学号吗？</p>
        <p style="color: #999; font-size: 14px;">解绑后将无法使用学生相关功能</p>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleUnbindDialogClose">取 消</el-button>
        <el-button type="danger" @click="submitUnbind" :loading="unbindLoading">确认解绑</el-button>
      </div>
    </el-dialog>

    <!-- 注销账户对话框 -->
    <el-dialog
      title="注销账户"
      :visible.sync="deleteAccountDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      :before-close="handleDeleteAccountDialogClose">
      <div class="delete-account-dialog">
        <el-alert
          title="危险操作警告"
          type="error"
          :closable="false"
          show-icon
          style="margin-bottom: 20px;">
          <div slot="description">
            <p style="font-weight: bold; margin-bottom: 8px;">注销账户将删除以下所有数据，此操作不可恢复：</p>
            <ul style="margin: 0; padding-left: 20px; line-height: 1.8;">
              <li>个人基本信息</li>
              <li>AMC学习记录和进度</li>
              <li>学习计划和方案</li>
              <li>答题记录和成绩</li>
              <li>其他相关数据</li>
            </ul>
            <p style="margin-top: 12px; color: #f56c6c; font-weight: bold;">请谨慎操作！</p>
          </div>
        </el-alert>

        <div v-if="userForm.email" style="margin-bottom: 20px;">
          <p style="font-size: 14px; color: #606266; margin-bottom: 10px;">
            验证码将发送至绑定邮箱：<span style="font-weight: bold;">{{ userForm.email }}</span>
          </p>
        </div>
        <div v-else style="margin-bottom: 20px;">
          <el-alert
            title="未绑定邮箱"
            type="warning"
            :closable="false"
            show-icon>
            <div slot="description">
              请先绑定邮箱后再进行注销操作
            </div>
          </el-alert>
        </div>

        <el-form :model="deleteAccountForm" :rules="deleteAccountRules" ref="deleteAccountForm" label-width="100px">
          <el-form-item label="验证码" prop="code">
            <div style="display: flex; gap: 10px;">
              <el-input
                v-model="deleteAccountForm.code"
                placeholder="请输入6位验证码"
                maxlength="6"
                :disabled="!userForm.email || deleteAccountLoading">
              </el-input>
              <el-button
                type="primary"
                :disabled="!userForm.email || deleteAccountCodeSending || deleteAccountCountdown > 0"
                :loading="deleteAccountCodeSending"
                @click="sendDeleteAccountCodeHandler"
                style="min-width: 120px;">
                {{ deleteAccountCountdown > 0 ? `${deleteAccountCountdown}秒后重试` : '发送验证码' }}
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDeleteAccountDialogClose" :disabled="deleteAccountLoading">取 消</el-button>
        <el-button type="danger" @click="submitDeleteAccount" :loading="deleteAccountLoading" :disabled="!userForm.email">确认注销</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  userAddClass,
  uploadAvatar,
  trackPresence,
  getUserInfo,
  updateUserInfo,
  searchUser,
  bindUser,
  getBindStudents,
  bindStudent,
  checkStudentBindStatus,
  getStudentBindInfo,
  unbindStudent,
  sendDeleteAccountCode,
  deleteAccount
} from '@/api/user'
import { setToken } from '@/utils/auth'
import { getTokenInfo, getRole } from '@/utils/jwtUtils'

export default {
  data() {
    return {
      isParent: false,
      fileDialogVisible: false,
      fileList: [],
      data: {},
      defaultAvatar: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNFNUU3RUIiLz4KPHN2ZyB4PSI4IiB5PSI4IiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDEyQzE0LjIwOTEgMTIgMTYgMTAuMjA5MSAxNiA4QzE2IDUuNzkwODYgMTQuMjA5MSA0IDEyIDRDOS43OTA4NiA0IDggNS43OTA4NiA4IDhDOCAxMC4yMDkxIDkuNzkwODYgMTIgMTIgMTJaIiBmaWxsPSIjOUM5QzlDIi8+CjxwYXRoIGQ9Ik0xMiAxNEM5LjMzIDE0IDcuMDEgMTUuMjQgNS4zNiAxNy4yNEM2LjY3IDE5LjI0IDkuMTkgMjAgMTIgMjBDMTQuODEgMjAgMTcuMzMgMTkuMjQgMTguNjQgMTcuMjRDMTYuOTkgMTUuMjQgMTQuNjcgMTQgMTIgMTRaIiBmaWxsPSIjOUM5QzlDIi8+Cjwvc3ZnPgo8L3N2Zz4K',
      form: {
        code: ''
      },
      isAdmin: false,
      addClassDialogVisible: false,
      // 个人信息表单数据
      userForm: {
        realName: '',
        gender: '',
        birthday: '',
        userName: '',
        phone: '',
        email: '',
        school: '',
        major: '',
        studentId: ''
      },
      rules: {
        realName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        major: [
          { required: true, message: '请输入专业', trigger: 'blur' }
        ]
      },
      loading: false,
      bindUserDialogVisible: false,
      searchUsername: '',
      searchResult: null,
      searchLoading: false,
      bindLoading: false,
      searchError: '',
      bindStudents: [],
      // 学生绑定相关数据
      studentBindDialogVisible: false,
      studentBindLoading: false,
      isStudentBound: false,
      studentBindInfo: null, // 学生绑定信息
      unbindDialogVisible: false, // 解绑对话框显示状态
      unbindLoading: false, // 解绑加载状态
      studentBindForm: {
        studentId: '',
        schoolName: '',
        name: ''
      },
      studentBindRules: {
        studentId: [
          { required: true, message: '请输入学号', trigger: 'blur' },
          { min: 1, max: 50, message: '学号长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        schoolName: [
          { required: true, message: '请输入学校名称', trigger: 'blur' },
          { min: 2, max: 200, message: '学校名称长度在 2 到 200 个字符', trigger: 'blur' }
        ]
      },
      // AMC 页面进入时的上下文
      fromAmc: false,
      amcLevelDisplay: '',
      amcYearDisplay: '',
      // 注销账户相关数据
      deleteAccountDialogVisible: false,
      deleteAccountLoading: false,
      deleteAccountCodeSending: false,
      deleteAccountCountdown: 0,
      deleteAccountForm: {
        code: ''
      },
      deleteAccountRules: {
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { pattern: /^\d{6}$/, message: '请输入6位数字验证码', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    // 获取角色判断是否是教师和管理员
    const role = getRole()
    this.userRole = role
    if (role === 3 || role === 2 || role === 4) {
      this.isAdmin = true
    }
    if (role === 5) {
      this.isParent = true
      // 获取家长id
      let parentId = null
      // 优先从 Vuex
      if (this.$store && this.$store.state.user && this.$store.state.user.data && this.$store.state.user.data.id) {
        parentId = this.$store.state.user.data.id
      }
      // 其次从 localStorage
      if (!parentId) {
        try {
          const userInfo = JSON.parse(localStorage.getItem('userInfo'))
          parentId = userInfo && (userInfo.id || (userInfo.data && userInfo.data.id))
        } catch (e) {}
      }
      // 如果还没有，主动请求一次用户信息
      if (!parentId) {
        getUserInfo().then(res => {
          if (res.code === 1) {
            parentId = res.data.id
            if (parentId) {
              this.fetchBindStudents(parentId)
            }
          }
        })
      } else {
        this.fetchBindStudents(parentId)
      }
    }
    console.log('当前是否是家长', this.isParent)
    // 检测是否由 AMC 页面进入
    this.fromAmc = this.$route && this.$route.query && this.$route.query.from === 'amc'
    // 从本地选择存储中读取 AMC 级别与年份（AMCCourse 写入的 amc_user_selection）
    try {
      const selection = JSON.parse(localStorage.getItem('amc_user_selection') || 'null')
      if (selection) {
        this.amcLevelDisplay = selection.level || ''
        this.amcYearDisplay = selection.year || ''
      }
    } catch (e) {}

    this.fetchUserInfo() // 获取个人详细信息

    // 如果是学生角色，检查绑定状态
    if (role === 1) {
      console.log('检测到学生角色，开始检查绑定状态')
      this.checkStudentBindStatus()
    }
    console.log('当前用户角色:', role, 'userRole:', this.userRole, 'isStudentBound:', this.isStudentBound)
  },
  methods: {
    // 修改文件逻辑
    handleFileChange(file, fileList) {
      this.fileList = fileList // 收集文件信息
    },
    // 移除文件处理方法
    handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.hasFiles = false
      }
    },
    // 上传文件逻辑
    importAvatar() {
      if (this.fileList.length > 0) {
        const formData = new FormData() // 创建FormData对象
        formData.append('file', this.fileList[0].raw) // 添加文件到formData
        uploadAvatar(formData)
          .then((res) => {
            if (res.code) {
              // 立即更新头像显示
              if (res.data) {
                this.data.avatar = res.data
              }
              // 重新获取用户信息
              this.fetchUserInfo()
              // 更新store中的用户信息，包括头像
              this.$store.dispatch('user/getInfo')
              this.$message.success('文件上传成功！')
              this.fileDialogVisible = false // 关闭对话框
              // 清空文件列表
              this.fileList = []
            } else {
              this.$message.error(res.msg || '头像上传失败！')
            }
          })
          .catch((error) => {
            console.error('文件上传失败：', error)
            this.$message.error('文件上传失败！')
          })
      } else {
        this.$message.warning('请选择文件后再上传！')
      }
    },
    // 添加班级按钮
    addClassBt() {
      this.addClassDialogVisible = true
    },
    // 添加班级逻辑
    addClass() {
      const params = { code: this.form.code }
      userAddClass(params).then((res) => {
        if (res.code) {
          this.addClassDialogVisible = false
          this.fetchUserInfo()
          this.$message({
            type: 'success',
            message: '加入成功'
          })
          setTimeout(() => {
            location.reload() // 延迟刷新，让用户先看到成功消息
          }, 1000)
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 以下是个人详细信息相关方法
    fetchUserInfo() {
      this.loading = true
      getUserInfo().then(response => {
        const { data } = response
        if (data) {
          // 设置基本信息到data
          this.data = data
          // 设置表单数据
          this.userForm = {
            realName: data.realName || '',
            gender: data.gender !== undefined && data.gender !== null ? Number(data.gender) : 1,
            birthday: data.birthday || '',
            userName: data.userName || '',
            phone: data.phone || '',
            email: data.email || '',
            major: data.major || '',
            studentId: data.studentId || ''
          }
        }
        this.loading = false
      }).catch(error => {
        console.error('获取用户信息失败', error)
        this.loading = false
        this.$message.error('获取用户信息失败')
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          updateUserInfo(this.userForm).then(response => {
            if (response.code) {
              this.$message.success('保存成功')
              // 更新基本信息
              this.fetchUserInfo()
            } else {
              this.$message.error(response.msg || '保存失败')
            }
            this.loading = false
          }).catch(error => {
            console.error('更新用户信息失败', error)
            this.loading = false
            this.$message.error('更新用户信息失败')
          })
        } else {
          console.log('表单验证失败')
          return false
        }
      })
    },
    CloseForm() {
      this.$router.go(-1) // 返回上一页
    },

    // 打开绑定用户弹窗
    bindUser() {
      this.bindUserDialogVisible = true
      this.searchUsername = ''
      this.searchResult = null
      this.searchError = ''
    },

    // 搜索用户
    async searchUser() {
      if (!this.searchUsername.trim()) {
        this.$message.warning('请输入用户名')
        return
      }

      this.searchLoading = true
      this.searchError = ''
      this.searchResult = null

      try {
        const res = await searchUser(this.searchUsername.trim())

        if (res.code === 1) {
          this.searchResult = res.data
          if (!this.searchResult) {
            this.$message.info('未找到该用户')
          }
        } else {
          this.searchError = res.msg || '搜索失败'
          this.$message.error(this.searchError)
        }
      } catch (error) {
        console.error('搜索用户失败:', error)
        this.searchError = '搜索用户失败，请重试'
        this.$message.error(this.searchError)
      } finally {
        this.searchLoading = false
      }
    },

    // 确认绑定用户
    async confirmBindUser(user) {
      if (!user) {
        this.$message.warning('请先搜索并选择要绑定的用户')
        return
      }

      try {
        this.bindLoading = true
        const userStore = this.$store.state.user
        let parentId = userStore.data && userStore.data.id
        const studentId = user.id
        console.log('parentId:', parentId, 'studentId:', studentId)

        if (!parentId) {
          // 主动获取一次
          const res = await getUserInfo()
          if (res.code === 1) {
            parentId = res.data.id
          }
        }

        if (!parentId) {
          this.$message.error('未获取到家长账号ID，请重新登录或联系管理员')
          this.bindLoading = false
          return
        }

        const res = await bindUser({
          parentId,
          studentId
        })

        if (res.code === 1) {
          this.$message.success('绑定成功')
          this.bindUserDialogVisible = false
          this.fetchUserInfo()
        } else {
          this.$message.error(res.msg || '绑定失败')
        }
      } catch (error) {
        console.error('绑定用户失败:', error)
        this.$message.error('绑定失败，请重试')
      } finally {
        this.bindLoading = false
      }
    },

    // 关闭弹窗时的处理
    handleBindDialogClose(done) {
      if (this.searchLoading || this.bindLoading) {
        this.$message.warning('操作正在进行中，请稍候...')
        return
      }
      this.$confirm('确认关闭？未保存的内容将会丢失')
        .then(_ => {
          this.searchUsername = ''
          this.searchResult = null
          this.searchError = ''
          done()
        })
        .catch(_ => {})
    },

    async fetchBindStudents(parentId) {
      try {
        const res = await getBindStudents(parentId)
        this.bindStudents = res.data || []
      } catch (e) {
        this.$message && this.$message.error('获取绑定学生信息失败')
      }
    },

    // 检查学生绑定状态
    async checkStudentBindStatus() {
      try {
        console.log('开始检查学生绑定状态...')
        const res = await checkStudentBindStatus()
        console.log('绑定状态检查结果:', res)
        if (res.code === 1) {
          this.isStudentBound = res.data
          console.log('设置绑定状态为:', this.isStudentBound)

          // 如果已绑定，获取绑定信息
          if (this.isStudentBound) {
            await this.loadStudentBindInfo()
          }
        }
      } catch (error) {
        console.error('检查学生绑定状态失败:', error)
        // 如果检查失败，默认显示绑定按钮
        this.isStudentBound = false
        console.log('由于API调用失败，设置绑定状态为false，显示绑定按钮')
      }
    },

    // 加载学生绑定信息
    async loadStudentBindInfo() {
      try {
        console.log('开始加载学生绑定信息...')
        const res = await getStudentBindInfo()
        console.log('学生绑定信息:', res)
        if (res.code === 1) {
          this.studentBindInfo = res.data
          console.log('设置学生绑定信息:', this.studentBindInfo)
        }
      } catch (error) {
        console.error('加载学生绑定信息失败:', error)
        this.studentBindInfo = null
      }
    },

    // 显示学生绑定对话框
    showStudentBindDialog() {
      this.studentBindDialogVisible = true
      this.studentBindForm = {
        studentId: '',
        schoolName: '',
        name: this.userForm.realName || this.data.realName || ''
      }
    },

    // 提交学生绑定
    async submitStudentBind() {
      try {
        // 表单验证
        const valid = await this.$refs.studentBindForm.validate()
        if (!valid) {
          return
        }

        this.studentBindLoading = true

        const res = await bindStudent(this.studentBindForm)

        if (res.code === 1) {
          this.$message.success('绑定成功')
          this.studentBindDialogVisible = false
          this.isStudentBound = true
          // 刷新用户信息
          this.fetchUserInfo()
          // 加载绑定信息
          await this.loadStudentBindInfo()
        } else {
          this.$message.error(res.msg || '绑定失败')
        }
      } catch (error) {
        console.error('绑定学生信息失败:', error)
        this.$message.error('绑定失败，请重试')
      } finally {
        this.studentBindLoading = false
      }
    },

    // 关闭学生绑定对话框
    handleStudentBindDialogClose() {
      this.studentBindDialogVisible = false
      this.studentBindForm = {
        studentId: '',
        schoolName: '',
        name: this.userForm.realName || this.data.realName || ''
      }
      // 重置表单验证状态
      if (this.$refs.studentBindForm) {
        this.$refs.studentBindForm.resetFields()
      }
    },

    // 显示解绑对话框
    showUnbindDialog() {
      this.unbindDialogVisible = true
    },

    // 关闭解绑对话框
    handleUnbindDialogClose() {
      this.unbindDialogVisible = false
    },

    // 提交解绑
    async submitUnbind() {
      try {
        this.unbindLoading = true

        const res = await unbindStudent()

        if (res.code === 1) {
          this.$message.success('解绑成功')
          this.unbindDialogVisible = false
          this.isStudentBound = false
          this.studentBindInfo = null
          // 刷新用户信息
          this.fetchUserInfo()
        } else {
          this.$message.error(res.msg || '解绑失败')
        }
      } catch (error) {
        console.error('解绑学生信息失败:', error)
        this.$message.error('解绑失败，请重试')
      } finally {
        this.unbindLoading = false
      }
    },
    // 头像加载失败处理
    handleAvatarError(event) {
      // 头像加载失败时，使用默认头像
      event.target.src = this.defaultAvatar
    },
    goBackToAMCCourse() {
      this.$router.push('/amc-course')
    },
    // 显示注销账户对话框
    showDeleteAccountDialog() {
      if (!this.userForm.email) {
        this.$message.warning('请先绑定邮箱后再进行注销操作')
        return
      }
      this.deleteAccountDialogVisible = true
      this.deleteAccountForm.code = ''
    },

    // 关闭注销账户对话框
    handleDeleteAccountDialogClose() {
      if (this.deleteAccountLoading || this.deleteAccountCodeSending) {
        this.$message.warning('操作正在进行中，请稍候...')
        return
      }
      this.deleteAccountDialogVisible = false
      this.deleteAccountForm.code = ''
      if (this.$refs.deleteAccountForm) {
        this.$refs.deleteAccountForm.resetFields()
      }
    },

    // 发送注销账户验证码
    async sendDeleteAccountCodeHandler() {
      if (!this.userForm.email) {
        this.$message.warning('请先绑定邮箱')
        return
      }

      this.deleteAccountCodeSending = true
      try {
        const res = await sendDeleteAccountCode()
        if (res.code === 1) {
          this.$message.success('验证码已发送至您的邮箱，请查收')
          // 开始倒计时
          this.deleteAccountCountdown = 60
          const timer = setInterval(() => {
            this.deleteAccountCountdown--
            if (this.deleteAccountCountdown <= 0) {
              clearInterval(timer)
            }
          }, 1000)
        } else {
          this.$message.error(res.msg || '验证码发送失败')
        }
      } catch (error) {
        console.error('发送验证码失败:', error)
        this.$message.error('验证码发送失败，请重试')
      } finally {
        this.deleteAccountCodeSending = false
      }
    },

    // 提交注销账户
    async submitDeleteAccount() {
      try {
        // 表单验证
        const valid = await this.$refs.deleteAccountForm.validate()
        if (!valid) {
          return
        }

        // 二次确认
        await this.$confirm(
          '确认要注销账户吗？此操作将永久删除您的所有数据，无法恢复！',
          '最终确认',
          {
            confirmButtonText: '确认注销',
            cancelButtonText: '取消',
            type: 'error',
            confirmButtonClass: 'el-button--danger'
          }
        )

        this.deleteAccountLoading = true

        const res = await deleteAccount(this.deleteAccountForm.code)

        if (res.code === 1) {
          this.$message.success('账户注销成功')
          this.deleteAccountDialogVisible = false

          // 清空本地存储
          localStorage.clear()
          sessionStorage.clear()

          // 延迟跳转到登录页面
          setTimeout(() => {
            this.$router.replace('/login')
          }, 1500)
        } else {
          this.$message.error(res.msg || '账户注销失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('注销账户失败:', error)
          this.$message.error('账户注销失败，请重试')
        }
      } finally {
        this.deleteAccountLoading = false
      }
    },

    // 重新制定计划：重置用户AMC计划（删除计划、进度、做题记录）并跳转到级别选择
    async recreatePlan() {
      // 单步弹窗：直接在同一个确认框中选择“清除记录/保留记录”
      // $confirm: 点确定→resolve, 点取消按钮→reject('cancel'), 点×→reject('close')
      let clearRecords = true
      try {
        await this.$confirm(
          '重新制定学习计划后，将清除当前学习进度和计划数据。\n\n' +
          '请同时选择是否清除做题记录：\n' +
          '• 点击"确定（清除记录）"：删除做题记录，从零开始\n' +
          '• 点击"取消（保留记录）"：保留做题记录，新计划将自动标记已完成题目',
          '重新制定计划',
          {
            confirmButtonText: '确定（清除记录）',
            cancelButtonText: '取消（保留记录）',
            distinguishCancelAndClose: true,
            type: 'warning'
          }
        )
        clearRecords = true
      } catch (action) {
        if (action === 'cancel') {
          clearRecords = false
        } else {
          return
        }
      }

      // 执行重置
      let userId = null
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        userId = userInfo && userInfo.id
      } catch (e) {
        console.error('解析userInfo失败:', e)
      }
      if (!userId && this.data && this.data.id) {
        userId = this.data.id
      }
      if (!userId) {
        this.$message.error('无法获取用户ID，请重新登录')
        return
      }

      const { resetStudyPlan } = require('@/api/studyPlan')
      const loading = this.$loading({
        lock: true,
        text: clearRecords ? '正在清理学习数据和做题记录...' : '正在清理学习数据（保留做题记录）...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        await resetStudyPlan(userId, null, clearRecords)
        loading.close()

        localStorage.removeItem('selectedAmcLevel')
        localStorage.removeItem('userAmcInfo')

        // 保留记录时写入标记，供 AMCPlanDetails 制定计划后回填 finished_id
        if (!clearRecords) {
          localStorage.setItem('preserveRecords', 'true')
        } else {
          localStorage.removeItem('preserveRecords')
        }

        this.$message.success(
          clearRecords
            ? '学习数据已清理，正在跳转到重新制定学习计划页面...'
            : '学习数据已清理（做题记录已保留），正在跳转到重新制定学习计划页面...'
        )
        setTimeout(() => {
          this.$router.replace({ path: '/amc-level-select', query: { recreate: 'true' } })
        }, 800)
      } catch (e) {
        loading.close()
        console.error('重置AMC信息失败:', e)
        this.$message.error('重置计划失败，请重试')
      }
    }
  },
  computed: {
    // 判断是否已加入班级
    hasJoinedClass() {
      return this.data && this.data.gradeName !== null && this.data.gradeName !== ''
    },
    // 获取头像URL
    avatarUrl() {
      const { getUserAvatarUrl } = require('@/utils/minio')
      const avatarUrl = this.data && this.data.avatar ? this.data.avatar : ''
      const processedUrl = getUserAvatarUrl(avatarUrl)
      return processedUrl || this.defaultAvatar
    }
  }
}
</script>

<style scoped>
/* 卡片样式 */
.item-contain {
  padding: 30px 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.box-card,
.bind-student-table {
  width: 70%;
  margin-bottom: 40px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.card-body {
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid #ebeef5;
}

.left {
  display: flex;
  flex-direction: column;
  width: 380px;
  height: 100%;
  padding: 60px;
  border-right: 1px solid rgb(228, 232, 235);
}

.left div {
  margin-bottom: 40px;
  font-size: 14px;
}

.left div span {
  display: inline-block;
  width: 115px;
}

.right {
  padding: 60px;
}

/* 个人详细信息表单样式 */
.detail-info-section {
  padding: 20px 0;
}

.user-info-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.avatar-section {
  margin-bottom: 30px;
}

.user-form {
  width: 600px;
  margin: 0 auto;
}

.required-field::before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}

.bind-user-dialog {
  padding: 20px 0;
}

.search-section {
  margin-bottom: 20px;
}

.search-input {
  width: 100%;
}

.search-result {
  margin-top: 20px;
}

.search-error {
  color: #F56C6C;
  margin: 10px 0;
  text-align: center;
}

.no-result {
  margin-top: 20px;
}

/* 表格样式优化 */
.el-table {
  margin-top: 15px;
}

.el-table .el-button {
  padding: 5px 10px;
}

/* 弹窗宽度调整 */
:deep(.el-dialog) {
  margin-top: 8vh !important;
}

/* 学生绑定对话框样式 */
.student-bind-dialog {
  padding: 20px 0;
}

.student-bind-dialog .el-form-item {
  margin-bottom: 20px;
}

.student-bind-dialog .el-alert {
  margin-bottom: 20px;
}

.student-bind-dialog .el-alert .el-alert__description p {
  margin: 5px 0;
  line-height: 1.5;
}

.form-item-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
  line-height: 1.4;
}

/* 头像样式 */
.avatar-container {
  position: relative;
  cursor: pointer;
  display: inline-block;
}

.user-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e4e7ed;
  transition: all 0.3s ease;
}

.avatar-container:hover .user-avatar {
  border-color: #409eff;
  transform: scale(1.05);
}

.avatar-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  font-size: 12px;
}

.avatar-container:hover .avatar-overlay {
  opacity: 1;
}

.avatar-overlay i {
  font-size: 16px;
  margin-bottom: 2px;
}

.avatar-overlay span {
  font-size: 10px;
  line-height: 1;
}
</style>
